import Img from "gatsby-image"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import styled from "styled-components"
import Hero from "./Hero"

const Text = styled.div.attrs(props => ({
  className: `${props.headingSize}`,
}))`
  font-weight: 200 !important;
`

const ImageAndTextSection = props => {
  const { image, text, layout = "left", headingSize = "display-4" } = props

  if (layout === "left" || layout === "right") {
    return (
      <Container fluid className="my-5">
        <Row className="d-flex align-items-center">
          <Col
            xs={{ span: 12 }}
            sm={{
              span: 6,
              order: layout === "right" && 2,
              offset: layout === "right" ? 0 : 1,
            }}
            className="mb-2"
          >
            {image.asset ? (
              <Img fluid={image.asset.fluid} />
            ) : (
              <img src={image} className="img-fluid" />
            )}
          </Col>
          <Col
            xs={{ span: 12 }}
            sm={{
              span: 5,
              order: layout === "right" && 1,
              offset: layout === "right" ? 1 : 0,
            }}
          >
            <Text
              className={layout === "right" && "text-left text-sm-right"}
              headingSize={headingSize}
            >
              {text}
            </Text>
          </Col>
        </Row>
      </Container>
    )
  } else if (layout === "hero") {
    return <Hero heading={text} image={image} headingSize={headingSize} />
  }
}

export default ImageAndTextSection
